export default "__VITE_ASSET__905b872e__"